'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/product');

require('../vendor/slick');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)("select[name='product-size'] option").each(function (i, e) {

  if (i >= 0) {

    var soldOutTerm = "Sold Out";
    var val = (0, _jquery2.default)(this).val();
    var selected = (0, _jquery2.default)(this).attr("selected");
    var soldOut = (0, _jquery2.default)(this).hasClass("option-soldout");
    var active, isAvailable, isDisabled;

    if (selected == "selected") {
      active = 'option-size-active';
    }

    if (val.indexOf(soldOutTerm) != -1) {
      isAvailable = false;
      isDisabled = "disabled";
    } else {
      isAvailable = true;
      isDisabled = "";
    }

    if (soldOut) {
      var text = val.replace(' - Sold Out', '');
      var el = "<label class='option-size option-size-soldout' for='" + i + "'>" + text + "</label>";
    } else {
      var text = this.textContent;
      var el = "<label class='option-size' for='" + i + "'>" + this.textContent + "</label>";
    }

    (0, _jquery2.default)("<input type='radio' name='r' class='" + active + "' " + isDisabled + "/>").attr("value", text).attr("id", i).attr("checked", selected == "selected").click(function () {
      (0, _jquery2.default)("select[name='Size']").val((0, _jquery2.default)(this).val());
      var tt = _jquery2.default.trim((0, _jquery2.default)(this).next('label').text());
      (0, _jquery2.default)("select[name='options[Size]']").val(tt).trigger('change');
      (0, _jquery2.default)('.option-size-active').removeClass('option-size-active');
      (0, _jquery2.default)(this).addClass('option-size-active');
    }).add((0, _jquery2.default)(el)).appendTo("#size-varient");
  }
});

(0, _jquery2.default)(document).ready(function () {

  (0, _jquery2.default)('body').on('click', '');
});

(0, _jquery2.default)(document).ready(function () {
  (0, _jquery2.default)('.slick-slider').slick({
    dots: true
  });
});

(0, _themeSections.load)('*');